"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "rotate(90, 12, 12)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.5,6.5H3V12a.5.5,0,0,0,.5.5H12v6H4.5A.5.5,0,0,0,4,19v4a.5.5,0,0,0,.5.5h15A.5.5,0,0,0,20,23V19a.5.5,0,0,0-.5-.5H13v-6h7.5A.5.5,0,0,0,21,12V6.5h2.5A.5.5,0,0,0,24,6V1a.5.5,0,0,0-.5-.5h-5A.5.5,0,0,0,18,1V6a.5.5,0,0,0,.5.5H20v5H13v-5h1.5A.5.5,0,0,0,15,6V1a.5.5,0,0,0-.5-.5h-5A.5.5,0,0,0,9,1V6a.5.5,0,0,0,.5.5H12v5H4v-5H5.5A.5.5,0,0,0,6,6V1A.5.5,0,0,0,5.5.5H.5A.5.5,0,0,0,0,1V6A.5.5,0,0,0,.5,6.5Z",
    fill: "#004864"
  })));
};

exports["default"] = _default;